import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Config from '../utils/config.service';

@Injectable({ providedIn: 'root' })
export default class InsuranceClaimFileService {
	private httpClient: HttpClient = inject(HttpClient);
	private config: Config = inject(Config);
	
	uploadFileToClaim(claimId, file, onSuccess, onError) {
		var formData: any = new FormData();
		formData.append('file', file);
		this.httpClient.post(this.config.getRestUrl() + 'insurance/api/v1/claim/file/new/' + claimId + '/upload/' + file.name, formData, {
			withCredentials: true
		}).toPromise().then(onSuccess).catch(onError);
	}
	
	deleteFileFromClaim(fileId, onSuccess, onError) {
		this.httpClient.delete(this.config.getRestUrl() + 'insurance/api/v1/claim/file/' + fileId, { withCredentials: true })
			.toPromise().then(onSuccess).catch(onError);
	}
	
}